/**
 * `EmailMessage.from_email` is whatever the provider gave us, so it is often a
 * full `Name <addr>` header rather than a bare address. The thread list has no
 * room for both, so it shows the human-readable half.
 */
const NAMED_ADDRESS = /^\s*"?([^"<]*?)"?\s*<([^>]+)>\s*$/

export function formatAddress(value: string): string {
  const match = NAMED_ADDRESS.exec(value)
  if (!match) return value.trim()
  return match[1].trim() || match[2].trim()
}
